module.exports = __webpack_public_path__ + "img/devis-contours-verts.svg";